/* Avicula – motiv obchodu: mobilní menu, hlavička při posunu, galerie na stránce kytice. */
(function () {
  'use strict';

  var toggle = document.querySelector('.nav-toggle');
  var nav = document.getElementById('hlavni-navigace');
  if (toggle && nav) {
    toggle.addEventListener('click', function () {
      var open = toggle.getAttribute('aria-expanded') === 'true';
      toggle.setAttribute('aria-expanded', String(!open));
      nav.classList.toggle('is-open', !open);
    });
    document.addEventListener('keydown', function (e) {
      if (e.key === 'Escape' && nav.classList.contains('is-open')) {
        toggle.setAttribute('aria-expanded', 'false');
        nav.classList.remove('is-open');
        toggle.focus();
      }
    });
  }

  var header = document.querySelector('.site-header');
  if (header) {
    var priPosunu = function () { header.classList.toggle('is-scrolled', window.scrollY > 8); };
    window.addEventListener('scroll', priPosunu, { passive: true });
    priPosunu();
  }

  var foto = document.getElementById('produkt-foto');
  var nahledy = document.querySelectorAll('.kytice__thumb[data-foto]');
  Array.prototype.forEach.call(nahledy, function (btn) {
    btn.addEventListener('click', function () {
      if (!foto) return;
      foto.removeAttribute('srcset');
      foto.src = btn.getAttribute('data-foto');
      foto.alt = btn.getAttribute('data-alt') || '';
      Array.prototype.forEach.call(nahledy, function (b) {
        b.setAttribute('aria-current', b === btn ? 'true' : 'false');
      });
    });
  });
})();
